import { CashRegisterReceiptsDetail } from './../../../components/Pages/Documents/CashRegisterReceipts/CashRegisterReceiptsDetail';
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CommodityWaybillsService } from "../../../services/documents/CommodityWaybillsService";
import { NFLookupCommodityWaybills } from "../../../components/Shared/NewForms/NFLookupCommodityWaybills";
import CashRegisterReceiptsList from '../../../components/Pages/Documents/CashRegisterReceipts/CashRegisterReceiptsList';
import { NFLookupCashRegisterReceipts } from '../../../components/Shared/NewForms/NFLookupCashRegisterReceipts';
import { CashRegisterReceiptsService } from '../../../services/documents/CashRegisterReceiptsService';
import { CreateCashRegisterReceiptsDto } from '../../../dtos/documents/CashRegisterReceipts/CreateCashRegisterReceiptsDto';

export const CashRegisterReceipts: IAppEntity = {
  entityType: "document",
  title: "Cash Register Receipts",
  pluralTitle: "Cash Register Receipts",
  apiUrl: "CashRegisterReceipts",
  apiEnum: ReferenceTypes.DocumentCashRegisterReceipt,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(CashRegisterReceiptsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashRegisterReceiptsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashRegisterReceipts, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new CashRegisterReceiptsService("CashRegisterReceipts"),
  getEmptyModel: () => {
    const model: CreateCashRegisterReceiptsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      createdDate: new Date(),
      documentNumber: "",
      status: 0,
      
      products: [],
      payments: [],
    };
    return model;
  },
};
